import { Component, Input } from "@angular/core";

type AlertType = "info" | "warn" | "danger";

@Component({
  selector: "alert",
  template: `
    <div
      class="my-alert text-sm rounded-lg"
      [ngClass]="'my-alert-' + type"
      role="alert"
    >
      <strong class="my-alert-title">{{ title }}</strong>
      <p class="my-alert-content">
        <ng-content></ng-content>
      </p>
    </div>
  `,
  styleUrls: ["./alert.component.scss"]
})
export class AlertComponent {
  @Input() title: string = "";
  @Input() type: AlertType = "info";
}